import { createPortal } from 'react-dom';

import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';
import { ContentModalExpiredProposalArbitrage } from '@/modals/ContentModalExpiredProposalArbitrage/ContentModalExpiredProposalArbitrage';

interface Props {
  onClose: () => void;
}

const ExpiredProposalModal = ({ onClose }: Props) =>
  createPortal(
    <ModaleDefaut
      content={<ContentModalExpiredProposalArbitrage closeExpiredProposalModal={onClose} />}
      size="large"
      onClickClose={onClose}
      mobileStyle="stick-to-bottom"
    />,
    document.body
  );

export default ExpiredProposalModal;
